//活动管理
export default [{
  path: '/activityManage',
  component: resolve => require(['../pages/activity/activityList.vue'], resolve),
  name: 'activityManage',
  title: "活动管理",
  meta: {
    title: "活动管理"
  }
},
  {
    path: '/addActivityManage',
    component: resolve => require(['../pages/activity/addActivity.vue'], resolve),
    name: 'addActivityManage',
    title: "活动管理",
    meta: {
      title: "活动管理"
    }
  },

  {
    path: '/setPrice',
    component: resolve => require(['../pages/activity/setPrice.vue'], resolve),
    name: 'setPrice',
    title: "设置售价",
    meta: {
      title: "设置售价"
    }
  },
  {
    path: '/activityClassifyManage',
    component: resolve => require(['../pages/activity/activityClassifyManage.vue'], resolve),
    name: 'activityClassifyManage',
    title: "活动分类管理",
    meta: {
      title: "活动分类管理"
    }
  },
  {
    path: '/activityRefund',
    component: resolve => require(['../pages/activity/order/refund/activityRefund.vue'], resolve),
    name: 'activityClassifyManage',
    title: "申请退款列表",
    meta: {
      title: "申请退款列表"
    }
  },
  {
    path: '/auditActivityRefund',
    component: resolve => require(['../pages/activity/order/refund/auditActivityRefund.vue'], resolve),
    name: 'auditActivityRefund',
    title: "活动订单退款审核",
    meta: {
      title: "活动订单退款审核"
    }
  },
  {
    path: '/activityorder',
    component: resolve => require(['../pages/activity/order/activityOrder.vue'], resolve),
    name: 'activityorder',
    title: "活动订单管理",
    meta: {
      title: "活动订单管理"
    }
  },
  {
    path: '/eventCheckIn',
    component: resolve => require(['../pages/activity/eventCheckIn.vue'], resolve),
    name: 'eventCheckIn',
    title: "活动签到",
    meta: {
      title: "活动签到"
    }
  },
  {
    path: '/strategyReco',
    component: resolve => require(['../pages/activity/strategyReco.vue'], resolve),
    name: 'strategyReco',
    title: "攻略推荐",
    meta: {
      title: "攻略推荐"
    }
  },
  {
    path: '/storeManage',
    component: resolve => require(['../pages/activity/storeManage.vue'], resolve),
    name: 'storeManage',
    title: "潮玩管理",
    meta: {
      title: "潮玩管理"
    }
  },
  // {
  //   path: '/storeOrder',
  //   component: resolve => require(['../pages/activity/storeactivitysManage.vue'], resolve),
  //   name: 'orderStore',
  //   title: "订单管理",
  //   meta: {
  //     title: "订单管理"
  //   }
  // },
  {
    path: '/userCard',
    component: resolve => require(['../pages/activity/storeCardManage.vue'], resolve),
    name: 'userCard',
    title: "潮玩核销",
    meta: {
      title: "潮玩核销"
    }
  },
  {
    path: '/storeClassifyManage',
    component: resolve => require(['../pages/activity/storeClassifyManage.vue'], resolve),
    name: 'storeClassifyManage',
    title: "潮玩分类",
    meta: {
      title: "潮玩分类"
    }
  },
  {
    path: '/satisfactionQuestionnaire',
    component: resolve => require(['../pages/activity/satisfactionQuestionnaire.vue'], resolve),
    name: 'satisfactionQuestionnaire',
    title: "满意度调查",
    meta: {
      title: "满意度调查"
    }
  },

];
